/**
 * Rounds `numberToRound` to the nearest multiple of `interval`.
 * @param numberToRound - The value to round.
 * @param interval - The interval to snap to.
 * @returns The nearest multiple of `interval`.
 */
export function roundToInterval(numberToRound: number, interval: number): number {
	return Math.round(numberToRound / interval) * interval;
}
